
import './App.css';

// Components
import Header from './Components/header/header';
import Header2 from './Components/header/header2';
import Container1 from './Components/Container/Container1'
import Container2 from './Components/Container/Container2';
import Container3 from './Components/Container/Container3';
import Container4 from './Components/Container/Container4';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <>
    <Header/>
    <Header2/>
    <Container1/>
    <Container2/>
    <Container3/>
    <Container4/>
    <Contact/>
    <Footer/>
    </>
  );
}

export default App;
